/// KL-49
export enum ImplementationOfDeficiencyPlan {
	None = 0,
	NotImplemented = 1,
	PartiallyImplemented = 2,
	Implemented = 3,
}

/** Every implementation of a deficiency plan but `None`, the absence of an assessment. */
export const SELECTABLE_IMPLEMENTATIONS_OF_DEFICIENCY_PLAN: readonly ImplementationOfDeficiencyPlan[] = [
	ImplementationOfDeficiencyPlan.NotImplemented,
	ImplementationOfDeficiencyPlan.PartiallyImplemented,
	ImplementationOfDeficiencyPlan.Implemented,
];
